'use client';
import React, { useState } from 'react';
import 'lightgallery.js/dist/css/lightgallery.css'; //Added by Aarif
import styled from 'styled-components';
import { Col, Container, Row } from 'react-bootstrap';
import { LightgalleryItem, LightgalleryProvider } from 'react-lightgallery';
import Masonry from 'react-layout-masonry';
import { theme } from '@/components/features/theme/theme';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import VideoSingle from '@/components/common/ui/single-item/VideoSingle';
import { useShowSetting } from '@/core/context/ShowSettingProvider';
import SelectInput from '@/components/common/ui/input/SelectInput';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';

gsap.registerPlugin(ScrollTrigger);

const Gallery = ({ data, padding, gallery }) => {
	// const galleryList = gallery?.data?.galleries?.list;

	const offset = useContainerOffset('.container');
	const scroll = useShowSetting()
	const [activeGalleryIndex, setActiveGalleryIndex] = useState(0);
	const isMobile = useDeviceTypeMobile()
	const handleClick = (index) => {
		setActiveGalleryIndex(index);
		const timeoutId = setTimeout(() => {
			scroll?.getScrollData?.update?.(); // Optional, if you're using smooth scroll
			ScrollTrigger.refresh();
		}, 100); // 50–100ms works well
		// Note: In a real implementation, you'd want to store this timeout ID for cleanup
	};

	const handleClickSelect = (index) => {
		setActiveGalleryIndex(index?.value);
		const timeoutId = setTimeout(() => {
			scroll?.getScrollData?.update?.(); // Optional, if you're using smooth scroll
			ScrollTrigger.refresh();
		}, 100); // 50–100ms works well
		// Note: In a real implementation, you'd want to store this timeout ID for cleanup
	};

	const PhotoItem = ({ image, group, classcu, title, date, imageCount }) => (
		<LightgalleryItem
			className={classcu ? classcu : ''}
			group={group}
			src={image}>
			<div className="image">
				<img
					src={image}
					className={classcu ? classcu : ''}
					style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
					alt="Gallery Item"
				/>
				<div className="count">
					<p>{imageCount} Images</p>
				</div>
				<div className="icon">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M39.2677 35.7323L29.3664 25.8309C31.3354 23.1427 32.5 19.83 32.5 16.25C32.5 7.28977 25.2102 0 16.25 0C7.28977 0 0 7.28977 0 16.25C0 25.2102 7.28977 32.5 16.25 32.5C19.83 32.5 23.1427 31.3354 25.8309 29.3664L35.7323 39.2677C36.2204 39.7559 36.8602 40 37.5 40C38.1398 40 38.7796 39.7559 39.2677 39.2677C40.2441 38.2915 40.2441 36.7085 39.2677 35.7323ZM5 16.25C5 10.0467 10.0467 5 16.25 5C22.4533 5 27.5 10.0467 27.5 16.25C27.5 22.4533 22.4533 27.5 16.25 27.5C10.0467 27.5 5 22.4533 5 16.25Z" fill="white" />
					</svg>
				</div>
			</div>
			<div className="date">
				<p>
					<svg width="32" height="2" viewBox="0 0 32 2" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 1H31" stroke="#152637" strokeOpacity="0.5" strokeLinecap="round" />
					</svg>

					<span>{date}</span>
				</p>
				<h5>{title}</h5>
			</div>
		</LightgalleryItem>
	);



	const formatDate = (dateStr) => {
		const options = { day: '2-digit', month: 'short', year: 'numeric' };
		return new Date(dateStr).toLocaleDateString('en-GB', options);
	};

	const types = [
		{value: 0, label: 'Photo Albums ('+data?.galleries?.list?.[0]?.items?.length+')'},
		{value: 1, label: 'Videos ('+data?.galleries?.list?.[1]?.items?.length+')'},
	];
	return (
		<StyledGallery
			data-scroll-section offset={offset}
			className={`gallery ${padding ? padding : ''}`}>

			<div className="filter-wrapper">
				<Container>
					<Row>
						<Col sm={12}>

							{
								!isMobile &&
								<ul>
									<li onClick={() => handleClick(0)} className={`${activeGalleryIndex === 0 ? 'active' : ''}`}>Photo Albums ({data?.galleries?.list?.[0]?.items?.length})</li>
									<li onClick={() => handleClick(1)} className={`${activeGalleryIndex === 1 ? 'active' : ''}`}>Videos ({data?.galleries?.list?.[1]?.items?.length})</li>
								</ul>
							}

							{
								isMobile &&
								<SelectInput onChange={(e) => handleClickSelect(e)} options={types} placeholder={'Select Showcase'} />

							}

						</Col>
					</Row>
				</Container>
			</div>


			<div className="filter-wrapper-content">
				<div className={`item-gallery-video-single ${activeGalleryIndex === 0 ? 'active' : ''}`}>
					<Container>
						<Row>
						<LightgalleryProvider onCloseAfter={() => window.location.hash=''}>
								<Container fluid className={'gallery__image'}>
									<Masonry     columns={4}
												 gap={16} className={'row '} >

										{data?.galleries?.list?.[0]?.posts &&
											data?.galleries?.list?.[0]?.posts?.map((e, index) => (
												<>
													{
														e?.list?.map((i, indexM) => {

															return (
																<div  key={indexM}  className={`${indexM === 0 ? null : 'hide'} gallery-single-col`}>
																	<PhotoItem
																		classcu={indexM === 0 ? null : 'hide'}
																		group={index - indexM}
																		key={indexM - indexM}
																		image={i?.full_path}
																		title={e?.posts?.post_name}
																		date={formatDate(e?.posts?.date)}
																		imageCount={e?.list?.length}
																		onClick={() => setActiveGalleryIndex(index)}
																	/>
																</div>

															);

													})}
												</>
											))}
									</Masonry>
								</Container>
							</LightgalleryProvider>

						</Row>
					</Container>
				</div>
				<div className={`item-gallery-video-single ${activeGalleryIndex === 1 ? 'active' : ''}`}>
					<Container>
						<Row>

							{data?.galleries?.list?.[1]?.posts &&
								data?.galleries?.list?.[1]?.posts?.map((e, index) => (
									<>
										{
											e?.list?.map((i, indexM) => {

												return (
													<Col md={4} key={indexM}>
														<VideoSingle img={i?.full_path} title={e?.posts?.post_name} date={formatDate(e?.posts?.date)} video_id={e?.posts?.subtitle} />
													</Col>
												);

											})}
									</>
								))}


						</Row>
					</Container>
				</div>
			</div>



		</StyledGallery>
	);
};
const StyledGallery = styled.section`
    background: #fff;
	position: relative;
	z-index: 99;
	
	

    .filter-wrapper {
        background: #DD223F;
        padding-top: 35px;
        padding-bottom: 35px;
        width: calc(100% - ${props => props.offset + 15}px);
        padding-left: ${props => props.offset + 15}px;
		position: relative;
		top: -50px;
		
		
		@media(max-width: 767px){
			top: 0;
			padding-right: 15px !important;
			padding-left: 15px !important;
			width: 100% !important;
			
		}

        .container {
            padding: 0 !important;
            margin: 0 auto;
            max-width: 100%;

            .row {
                margin: 0;
            }

            .col-sm-12 {
                padding: 0;
            }
        }

        ul {

            display: flex;
            flex-wrap: nowrap;
            gap: 30px;

            li {
                flex: 0 0 calc(25% - 30px);
                max-width: calc(25% - 30px);
                font-weight: 700;
                font-size: 1.5rem; /* 24px */
                line-height: 1.75rem; /* 28px */
                letter-spacing: 0;
                color: rgba(255, 255, 255, 0.5);
                cursor: pointer;
                transition: ${theme.transition};

                &:hover {
                    color: #fff;
                }

                &.active {
                    color: #fff;

                }
            }
        }
    }


    .filter-wrapper-content {
        position: relative;
        padding-top: 70px;
        padding-bottom: 100px;


        .item-gallery-video-single {
            position: relative;
            top: 0;
            transition: ${theme.transition};
            opacity: 0;
            visibility: hidden;
            transform: translateY(25px);
            height: 0;
            width: 100%;
			display: none;

            &.active {
                height: auto;
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
				display: block;
            }

            .gallery-single-col {
                &.hide {
                    width: 100%;
                    display: none;
                }
            }

            .react_lightgallery_item {

				cursor: pointer;
				&:hover{
					.image{
						.icon{
							opacity: 1;
						}
					}
				}
                .image {
                    border-radius: 5px;
                    position: relative;
                    overflow: hidden;

                    .icon {
						position: absolute;
						inset: 0;
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						background: #00000080;
						opacity: 0;
						transition: ${theme.transition};
                    }

                    .count {
                        position: absolute;
                        right: 20px;
                        bottom: 15px;
                        z-index: 2;
                        border-radius: 4px;
                        padding: 4px 8px;
                        gap: 10px;
                        background: #152637;

                        p {
                            font-weight: 500;
                            font-size: 1rem; /* 16px */
                            line-height: 1.5rem; /* 24px */
                            letter-spacing: 0;
                            text-align: right;
                            color: white;
                        }

                    }

                    img {
                        border-radius: 5px;
                    }
                }

                img {
                    width: 100%;

                    &.hide {
                        display: none;
                        width: 0;
                        height: 0;
                    }
                }

                .date {
                    margin-top: 15px;
                    margin-bottom: 15px;

                    p {
                        font-weight: 500;
                        font-size: 1rem; /* 16px */
                        line-height: 1.5rem; /* 24px */
                        letter-spacing: 0;
                        display: flex;
                        align-items: center;
                        color: rgba(21, 38, 55, 0.5);
                        gap: 15px;
                    }
                }

                h5 {
                    color: #152637;
                    font-weight: 500;
                    font-size: 1.25rem; /* 20px */
                    line-height: 1.75rem; /* 28px */
                    letter-spacing: 0;

                }
            }

            .gallery__image {
                margin-bottom: 30px;


                .single {
                    cursor: pointer;
                }
            }

        }
    }





`;

export default Gallery;
